var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.104 21.7638C16.796 21.7638 18.1519 23.1331 18.1519 24.8371V28.928C18.1519 30.62 16.796 32 15.104 32H11.048C9.36799 32 8 30.62 8 28.928V24.8371C8 23.1331 9.36799 21.7638 11.048 21.7638H15.104ZM28.952 21.7638C30.632 21.7638 32 23.1331 32 24.8371V28.928C32 30.62 30.632 32 28.952 32H24.896C23.204 32 21.8481 30.62 21.8481 28.928V24.8371C21.8481 23.1331 23.204 21.7638 24.896 21.7638H28.952ZM15.104 8C16.796 8 18.1519 9.38002 18.1519 11.0732V15.1641C18.1519 16.8681 16.796 18.2362 15.104 18.2362H11.048C9.36799 18.2362 8 16.8681 8 15.1641V11.0732C8 9.38002 9.36799 8 11.048 8H15.104ZM28.952 8C30.632 8 32 9.38002 32 11.0732V15.1641C32 16.8681 30.632 18.2362 28.952 18.2362H24.896C23.204 18.2362 21.8481 16.8681 21.8481 15.1641V11.0732C21.8481 9.38002 23.204 8 24.896 8H28.952Z",
    fill: "#EFF2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShows);
export default __webpack_public_path__ + "static/media/shows.be1e32c1df2259d97bb7a4b177ad4e29.svg";
export { ForwardRef as ReactComponent };